<template keep-alive>
  <section class="swiper-container" ref="slider">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>

    <nav arial-label="Slides Navigation" class="flex mt-4 pl-8 md:pl-16">
      <div class="swiper-prev p-2 cursor-pointer" aria-label="Previous Slide">
        <svg-icon name="arrow-left" classes="text-burgundy-600"></svg-icon>
      </div>

      <div class="swiper-next p-2 cursor-pointer" aria-label="Next Slide">
        <svg-icon name="arrow-right" classes="text-burgundy-600"></svg-icon>
      </div>

      <a
        class="flex items-center uppercase font-sans ml-auto mr-8 md:mr-12 text-2xl tracking-wider"
        href="/news"
      >
        More News
        <svg-icon
          name="arrow-right-long"
          classes="text-burgundy-500 ml-2 h-4 w-8"
        ></svg-icon>
      </a>
    </nav>
  </section>
</template>

<script>
import UUID from "@/lib/uuid.js";
import { Swiper, Navigation, Pagination, Keyboard, A11y } from "swiper";
Swiper.use([Navigation, Pagination, Keyboard, A11y]);
import "swiper/swiper-bundle.css";

const defaultOptions = {
  slidesPerView: 1,
  spaceBetween: 32,
  grabCursor: true,
  // autoHeight: true,
  slidesOffsetBefore: 32,
  slidesOffsetAfter: 32,
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-next",
    prevEl: ".swiper-prev",
  },
  breakpoints: {
    420: {
      slidesPerView: 1.25,
    },
    720: {
      slidesPerView: 2,
    },
    768: {
      slidesOffsetBefore: 64,
    },
    1100: {
      slidesPerView: 3,
    },
    1600: {
      slidesPerView: 4,
    },
  },
};

export default {
  mixins: [UUID],

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    const options = Object.assign({}, defaultOptions, this.options);
    return {
      mergedOptions: options,
    };
  },

  mounted() {
    new Swiper(this.$refs.slider, this.mergedOptions);
  },
};
</script>

<style lang="postcss">
.swiper-slide {
  height: auto;
}
</style>
